import { TItemDescriptions } from 'factions/factionTypes'
import { tagAs } from 'factions/metatagger'
import { DAUGHTERS_OF_KHAINE } from 'meta/factions'
import {
  CHARGE_PHASE,
  COMBAT_PHASE,
  DURING_GAME,
  END_OF_TURN,
  HERO_PHASE,
  MOVEMENT_PHASE,
  SAVES_PHASE,
  START_OF_HERO_PHASE,
  START_OF_ROUND,
} from 'types/phases'

const BattleTraits = {
  // Daughters of Khaine Allegiance
  [DAUGHTERS_OF_KHAINE]: {
    effects: [
      {
        name: `Annoited Ritualist - Start of First Battle Round`,
        desc: `Declare: If there are no friendly anointed units on the battlefield, pick a friendly non-Unique Daughters of Khaine Hero on the battlefield to be the target. 
        Effect: The target is anonited for the rest of the battle, even if it has been destroyed. Friendly anointed units on the battlefield treat Exalted abilities on the warscrolls of friendly anointed units that have been destroyed as if they were on their warscrolls.`,
        when: [START_OF_ROUND],
      },
      {
        name: `Bloody Succession - Passive`,
        desc: `Effect: Each time a friendly anointed unit is destroyed, after removing it from play, you can immediately use the Anointed Ritualist ability as if it were the start of the first battle round.`,
        when: [DURING_GAME],
      },
      {
        name: `Strident War Cry - Once Per Turn - Reaction: You declared a Charge ability for an anointed unit`,
        desc: `Used by: That anointed unit.
        Effect: Pick a friendly non-Hero Daughters of Khaine unit that is not in combat, is wholly within 12" of that anointed unit and has not charged this turn to be the target. If that anointed unit charges, after that Charge ability has been resolved, the target can immediately use the Charge ability even if it is not your Charge phase.
        In addition, you can reroll charge rolls for the target for the rest of the phase.`,
        when: [CHARGE_PHASE],
      },
      {
        name: `Blood Rites - Passive`,
        desc: `Effect: You perform a blood rite each time:
        An enemy unit is destroyed and any damage points were allocated to that unit by a friendly anointed unit's combat attacks in the same turn.
        A friendly anointed unit is destroyed.
        A friendly unit contesting an objective you control is destroyed.
        An enemy unit is destroyed by a friendly Daughters of Khaine unit's attacks and any models in that enemy unit were contesting an objective you do not control in the same phase.
        A unit (friendly or enemy) is destroyed and it was within 3" of a Place of Power at the start of the phase.`,
        when: [DURING_GAME],
      },
      {
        name: `Blessings of Khaine - Once Per Turn`,
        desc: `Declare: You can only use this ability if you performed any blood rites this turn.
        Effect: Pick 1 of the following blessings that is not active. That blessing is active. while a blessing is active, its effect applies to friendly Daughters of Khaine units. The effects of more than 1 blessing can apply to a unit at the same time.
        Blessing of Ruthlessness: Add 1 to hit rolls for those units' combat attacks.
        Blessing of Hatred: Add 1 to wound rolls for those units' combat attacks.
        Blessing of Haste: Add 3" to those units' Move characteristic.
        Blessing of Zeal: If those units charged in the same turn, they have Ward(5+) for the rest of the turn.
        Blessing of Shadow: Subtract 1 from hit rolls for shooting attacks that target those units.
        Blessing of Cruelty: Those units can use Charge and/or Shoot abilities even if they have used a Retreat ability in the same turn.
        Blessing of Clarity: Add 1 to chanting rolls and casting rolls for those units.`,
        when: [END_OF_TURN],
      },
      {
        name: `Shrine of Dark Tribute (Faction Terrian) - Call to Murder`,
        desc: `Effect: Pick a blessing from the Blessings of Khaine ability that is active. That blessing is no longer active. Then, pick a blessing that is not active. That blessing is now active.`,
        when: [HERO_PHASE],
      },
      {
        name: `Shrine of Dark Tribute (Faction Terrian) - In Dark Communion`,
        desc: `Declare: Pick a friendly Daughters of Khaine Wizard or Priest within 3" of this terrain feature to be the target.
        Effect: The target is in dark communion until this terrain feature uses this ability again or until this terrain feature is removed from the battlefield, which ever comes first. While the target is in dark communion, you can reroll 1 casting roll or 1 chanting roll for the target each turn.`,
        when: [HERO_PHASE],
      },
    ],
  },
} satisfies TItemDescriptions

export default tagAs(BattleTraits, 'battle_trait')
